export const DEFAULT_DATA = {
  id: '',
  instruction: null,
  actions: null,
  activeStep: '',
  timeline: [],
  product: {
    price: '',
    title: '',
    image: '',
    tag: '',
    customerAssessment: null,
  },
  customer: {
    address: null,
    identityDocuments: [],
    trackingNumber: {},
    transferCertificate: {},
  },
}

export const SEE_COUNTER_OFFER = 'refurbisherViewCounterOffer'
